import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment";
import Select, { components } from "react-select";
import { ClipLoader } from 'react-spinners';
import ConversationMembersModal from './ConversationMembersModal'



class Conversations extends React.Component {
  state = {
    convoToggled: false,
    action: null,
    currentConversationId: null,
    messageBody: '',
    conversations: [],
    messages: [],
    newConversation: {
      recipients: [],
      body: ''
    },
    recipients: [],
    loadingConversations: true,
    loadingMessages: true,
    sendingMessage: false,
    conversationMembersModalVisible: false
  }

  componentDidMount() {
    this.getConversations();
    this.getRecipients();
    App.cable.subscriptions.create("ChatChannel", {
      received: (data) => {
        this.updateMessagesAndConversations(data);
        this.addNewConversations(data);
        this.scrollToBottom();
      }
    });
  }

  getRecipients() {
    var recipients = this.state.recipients


    this.setState({ recipients })
    $.ajax(`/organizations/${this.props.organization_name}/users.json`).then(users => {
      this.setState({
        recipients: [
          ...this.state.recipients,
          ...users
        ]
      })
    });
    $.ajax(`/organizations/${this.props.organization_name}/groups.json`).then(groups => {
      this.setRecipientsToSendToAllStaffOfGroups(groups)
      this.props.organization_is_sober_home && this.setRecipientsToSendToAllResidentsOfGroups(groups)
    });
  }

  setRecipientsToSendToAllStaffOfGroups(groups){
    var staffGroupMacros = []
    groups.map((group)=> {
      staffGroupMacros.push({
        ...group,
        label: `All Staff from ${group.label}`,
        name: `All Staff from ${group.label}`,
        macro: `group_staff`,
      })
    })


    this.setState({
      recipients: [
        ...this.state.recipients,
        ...staffGroupMacros
      ]
    })
  }

  setRecipientsToSendToAllResidentsOfGroups(groups){
    var clientGroupMacros = []
    var only_sober_living_groups = groups.filter(group=>group.kind === 'sober living')
    only_sober_living_groups.map((group)=> {
      clientGroupMacros.push({
        ...group,
        label: `Current Clients from ${group.label}`,
        name: `Current Clients from ${group.label}`,
        macro: `group_current_clients`,
        value: `group_current_clients_${group.id}`,
      })
      // clientGroupMacros.push({
      //   ...group,
      //   label: `Alumni Clients from ${group.label}`,
      //   name: `Alumni Clients from ${group.label}`,
      //   macro: `group_alumni_clients`,
      //   value: `group_alumni_clients_${group.id}`,
      // })
    })
    this.setState({
      recipients: [
        ...this.state.recipients,
        ...clientGroupMacros
      ]
    })
  }

  scrollToBottom = (type="smooth") => {
    if(this.messagesEnd) {
      this.messagesEnd.scrollIntoView({ behavior: type });
    }
  }

  updateMessagesAndConversations(data) {
    this.setState({
      ...this.state,
      messages: [
        ...this.state.messages,
        data.message
      ],
      conversations: this.state.conversations.map(c => {
        if(c.id == data.message.conversation_id) {
          return {
            ...c,
            lastMessage: data.message,
            updatedAt: data.message.createdAt,
            unreadCount: data.message.sender.id == this.props.current_user_id ?
              c.unreadCount : c.unreadCount + 1
          }
        }

        return c
      })
    });
  }

  addNewConversations(data) {
    if(!this.state.conversations.find(c => c.id == data.message.conversation_id)) {
      this.getConversations();
    }
  }

  getConversations() {
    const url = `/organizations/${this.props.organization_name}/conversations.json`
    $.ajax({ url })
      .then(conversations => {
        this.setState({
          conversations,
          loadingMessages: false
        })
      }).then(response => {
        const { conversations } = this.state
        if ( conversations && conversations.length > 0) {
          this.handleConversationClick(conversations[0].id)
        }
      })
  }

  getMessages(conversationId) {
    this.setState({ loadingMessages: true })
    
    const url = `/organizations/${this.props.organization_name}/conversations/${conversationId}/messages.json`
    $.ajax({ url })
      .then(messages => {
        this.setState({
           messages,
           loadingMessages: false
        })
      }).then(response => {
        this.scrollToBottom('auto')
      })
  }

  handleConversationClick(conversationId) {
    this.getMessages(conversationId);
    this.markConversationRead(conversationId);
    this.setState({
      ...this.state,
      currentConversationId: conversationId,
      action: 'show',
      conversations: this.state.conversations.map(c => {
        if(c.id == conversationId) {
          return {
            ...c,
            unreadCount: 0
          }
        }

        return c
      })
    })
    this.handleToggleConversations(false)
  }

  markConversationRead(conversationId) {
    $.ajax(`/organizations/${this.props.organization_name}/conversations/${conversationId}/mark_as_read.json`, {
      method: 'PATCH'
    });
  }

  replyToConversation(conversationId, body) {
    this.setState({ sendingMessage: true })
    return $.ajax(`/organizations/${this.props.organization_name}/conversations/${conversationId}/reply.json`, {
      method: 'POST',
      data: {
        message: {
          body: body
        }
      }
    }).then( response  => {
      this.setState({
        ...this.state,
        messageBody: ''
      });
    }).then( response => {
      this.setState({ sendingMessage: false })
      this.scrollToBottom()
    })
  }

  createNewMessage() {
    const users  = this.state.newConversation.recipients.filter(r => r.type == 'User').map(r => r.id);
    
    const macros = this.state.newConversation.recipients.filter(r => !!r.macro ).map(r => (({ id, macro, label, type }) => ({ id, macro, label, type }))(r));
    const global_macros = macros.filter(r => r.type == 'Global')
    const staff_group_macros = macros.filter(r => r.macro == 'group_staff')
    const client_group_macros = macros.filter(r => r.type == 'Group' && r.macro != 'group_staff')

    this.setState({ sendingMessage: true })
    $.ajax(`/organizations/${this.props.organization_name}/conversations.json`, {
      method: 'POST',
      data: {
        macros: JSON.stringify({
          global_macros,
          staff_group_macros,
          client_group_macros,
        }),
        message: {
          recipients: users,
          body: this.state.newConversation.body,
        }
      }
    }).then(conversation => {
      this.getMessages(conversation.id);
      this.setState({
        sendingMessage: false,
        conversations: [
          conversation,
          ...this.state.conversations
        ],
        newConversation: {
          recipients: [],
          body: ''
        },
        action: 'show',
        currentConversationId: conversation.id
      });
    });
  }

  handleSendMessage() {
    const users  = this.state.newConversation.recipients.filter(r => r.type == 'User').map(r => r.id);
    
    const macros = this.state.newConversation.recipients.filter(r => !!r.macro ).map(r => (({ id, macro, label, type }) => ({ id, macro, label, type }))(r));
    const global_macros = macros.filter(r => r.type == 'Global')
    const staff_group_macros = macros.filter(r => r.macro == 'group_staff')
    const client_group_macros = macros.filter(r => r.type == 'Group' && r.macro != 'group_staff')

    this.setState({ sendingMessage: true })
    $.ajax(`/organizations/${this.props.organization_name}/conversations.json`, {
      data: {
        user_ids: [...users, this.props.current_user_id],
        macros: JSON.stringify({
          global_macros,
          staff_group_macros,
          client_group_macros,
        })
      }
    }).then(conversations => {
      if(conversations.length > 0) {
        this.replyToConversation(conversations[0].id, this.state.newConversation.body);
        this.getMessages(conversations[0].id);
        this.setState({
          sendingMessage: false,
          action: 'show',
          currentConversationId: conversations[0].id,
          newConversation: {
            recipients: [],
            body: ''
          }
        });
      } else {
        this.createNewMessage();
      }
    });
  }

  handleToggleConversations(val){
    this.setState({
      convoToggled: val
    })
  }

  customRecipientOption(props) {
    const currentOccupancies = props.data.occupancies &&
      props.data.occupancies.filter(o => o.status == "Current")
    const status = () => {
      if(currentOccupancies.length > 0) {
        return 'Current';
      } else if(props.data.occupancies.filter(o => o.status == "Past").length > 0) {
        return 'Alumni';
      } else if(props.data.roles.filter(r => r.name == "resident").length > 0) {
        return 'Lead';
      }
    };

    return (
      <components.Option {...props}>
        <div>
          {
            props.data.type == 'Group' &&
            <div className="d-inline">
              <i className="fas fa-home" />
              <span className="mx-1"> {props.data.name}</span>
            </div>
          }
          {
            props.data.type == 'Global' &&
            <div className="d-inline">
              <i className="fas fa-users" />
              <span className="mx-1"> {props.data.name}</span>
            </div>
          }
          {
            props.data.type == 'User' &&
            <div className="d-inline">
              <i className="fas fa-user" />
              <span className="mx-1"> {props.data.name}</span>
            </div>
          }
          {
            props.data.type === 'User' &&
            status() &&
            <span className="badge badge-primary">{status()}</span>
          }
          {
            props.data.type === 'User' && currentOccupancies.map((occupancy, index) => {
              if(occupancy.group) {
                return <span className="badge badge-info ml-1" key={index}>{occupancy.group.name}</span>
              }
            })
          }
        </div>
      </components.Option>
    );
  }

  customMultiValueLabel(props) {
    const currentOccupancies = props.data.occupancies &&
      props.data.occupancies.filter(o => o.status == "Current")
    const status = () => {
      if(currentOccupancies.length > 0) {
        return 'Current';
      } else if(props.data.occupancies.filter(o => o.status == "Past").length > 0) {
        return 'Alumni';
      } else if(props.data.roles.filter(r => r.name == "resident").length > 0) {
        return 'Lead';
      }
    };

    return (
      <components.MultiValueLabel {...props}>
        <div>
          {
            props.data.type == 'Group' &&
            <div>
              <i className="fas fa-home mr-2 ml-1" />
              <span>{props.data.name}</span>
            </div>
          }
          {
            props.data.type == 'Global' &&
            <div>
              <i className="fas fa-users mr-2 ml-1" />
              <span> {props.data.name}</span>
            </div>
          }
          {
            props.data.type == 'User' &&
            <div>
              <i className="fas fa-user mr-2 ml-1" />
              <span> {props.data.name}</span>
            </div>
          }
          {
            props.data.type === 'User' &&
            status() &&
            <span className="badge badge-primary">{status()}</span>
          }
          {
            props.data.type === 'User' && currentOccupancies.map((occupancy, index) => {
              if(occupancy.group) {
                return <span className="badge badge-info ml-1" key={index}>{occupancy.group.name}</span>
              }
            })
          }
        </div>
      </components.MultiValueLabel>
    )
  }

  sortRecipients(){
    const { recipients } = this.state
    const staff_groups = recipients.filter(recipient => recipient.macro == 'group_staff')
    const client_groups = recipients.filter(recipient => recipient.type == 'Group' && recipient.macro != 'group_staff')
    const globals = recipients.filter(r => r.type == 'Global');
    const staff = recipients.filter(recipient => recipient.roles && recipient.roles.some(roles => roles.name != 'resident'))
    const clients = recipients.filter(recipient => recipient.roles && recipient.roles.some(roles => roles.name == 'resident'))
    return [
      {
        label: 'Global',
        options: globals
      },
      {
        label: 'Staff By Facility',
        options: staff_groups
      },
      {
        label: 'Clients By Facility',
        options: client_groups
      },
      {
        label: 'Staff',
        options: staff
      },
      {
        label: 'Clients',
        options: clients
      },
    ]
  }

  ConversationTitle = ({conversation, showInfoButton}) => {
    const title = conversation.subject != 'Staff Message' ? 
      conversation.subject : 
      conversation.recipients.filter(r => r.id != this.props.current_user_id).map(r => r.name).join(', ')
    return (
      <div className="pr-3 d-flex align-items-center">
        <div className="one-line-of-text">
          {title}
          {conversation.subject !== 'Staff Message' && ` (created on ${moment(conversation.created_at).format("MMMM D, YYYY")})`}
        </div>
        {showInfoButton && <div className="text-primary cursor-pointer fas fa-info-circle d-inline ml-1" onClick={()=>this.setState({conversationMembersModalVisible: true})}></div>}
      </div>
    )
  }

  handeSendMessage = () => {
    !this.state.sendingMessage && this.replyToConversation(this.state.currentConversationId, this.state.messageBody)
  }

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.handeSendMessage();    
    }
  }

  handleDelete = (conversation) => {
    $.ajax({
      url: `/organizations/${this.props.organization_name}/conversations/${conversation.id}`,
      method: 'DELETE',
      success: (data) => {
        const conversationIndex = this.state.conversations.findIndex(c => c.id === conversation.id)
        this.state.conversations.splice(conversationIndex, 1)
        this.setState({ conversationMembersModalVisible: false, currentConversationId: null})
      }
    })

  }

  render() {
    const { convoToggled, sendingMessage, conversationMembersModalVisible } = this.state
    const { ConversationTitle } = this
    return (
      <div id="conversations" className="row">
        <ConversationMembersModal 
          canDelete={this.props.can_delete}
          show={conversationMembersModalVisible}
          handleClose={()=>this.setState({conversationMembersModalVisible: false})}
          handleDelete={(conversation) => this.handleDelete(conversation)}
          conversation={this.state.conversations.find(c => c.id == this.state.currentConversationId)}/>
        <div className={classNames({
          "d-none" : !convoToggled,
          "col-xs-12 col-lg-4 m-0 h-100 pl-0 p-0 d-lg-inline-block" : true,
        })}>
          <div className="card h-100 mb-0">
            <div className="card-header d-flex align-items-center" style={{height: '60px'}}>
              { (this.state.loadingMessages || this.state.sendingMessage) && <i className="fas fa-circle-notch fa-spin" /> }
              Conversations
              <button 
                onClick={() => this.handleToggleConversations(false)} 
                className='float-right btn btn-info btn-sm -xs-inline d-lg-none'> 
                  <span className='fas fa-times'></span>
              </button>
            </div>
            <div className="card-block p-0 conversations-sidebar">
              <div className="h-100 list-group">
                {
                  this.state.action == 'new' ? (
                    <a
                      href="#"
                      className="list-group-item list-group-item-action active"
                      onClick={(e) => e.preventDefault()}>
                      <strong>
                        {
                          this.state.newConversation.recipients.length ? (
                            this.state.newConversation.recipients
                              .filter(r => r.value != this.props.current_user_id)
                              .map(r => r.label).join(', ')
                          ) : (
                            'New Conversation'
                          )
                        }
                      </strong>
                      <p className="mb-0">{this.state.newConversation.body}</p>
                    </a>
                  ) : null
                }
                {
                  this.state.conversations.length > 0 ?
                  this.state.conversations
                    .sort((a, b) => moment(b.updatedAt).diff(moment(a.updatedAt))).map(c => (
                    <a
                      href="#"
                      key={c.id}
                      className={
                        classNames('list-group-item list-group-item-action', {
                          'active': c.id == this.state.currentConversationId && this.state.action == 'show'
                        })
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        this.handleConversationClick(c.id);
                      }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <strong className="mb-0">
                          <ConversationTitle conversation={c}/>
                        </strong>
                        {
                          c.unreadCount > 0 ? (
                            <span className="badge badge-primary badge-pill">{c.unreadCount}</span>
                          ) : null
                        }
                      </div>
                      <p className="mb-0 last-message-body">{c.lastMessage.body}</p>
                      <small className='text-muted' >{moment(c.updatedAt).format('MM/DD/YYYY hh:mm A')}</small>
                    </a>
                  )):
                  <div className="text-center p-5 text-muted"><i>No Conversations</i></div>
                }
              </div>
            </div>
          </div>
        </div>
        <div className={classNames({
          "col-xs-12 col-lg-8 m-0 h-100 p-0 pl-0": true,
          "d-none" : convoToggled
        })}>
          <div className="card h-100 w-100 mb-0" style={{borderLeft: 'none'}}>
            <div className="card-header d-flex align-items-center justify-content-between conversation-header" style={{height: '2em'}}>
              <button 
                ref={(rr) => { this.messagesHeader = rr }} 
                onClick={() => this.handleToggleConversations(true)} 
                className='btn btn-info btn-sm d-xs-inline d-lg-none'  
                style={{marginRight: '8px'}}>
                  <i className='fas fa-arrow-left'></i>
              </button>
              <div className="one-line-of-text">
                {
                  this.state.action == 'show' ? (
                    this.state.currentConversationId ? 
                    <ConversationTitle showInfoButton conversation={this.state.conversations.find(c => c.id == this.state.currentConversationId)}/> : 'Choose Conversation'
                  ) : null
                }
                {
                  this.state.action == 'new' ? (
                    this.state.newConversation.recipients.length ? (
                      this.state.newConversation.recipients
                        .filter(r => r.id != this.props.current_user_id)
                        .map(r => r.label).join(', ')
                    ) : 'New Conversation'
                  ) : null
                }
              </div>
              <button
                className="btn btn-sm btn-info"
                onClick={() => {
                  this.setState({
                    action: 'new'
                  })
                }}>
                New Message
              </button>
            </div>
            <div className="w-100 p-3">
              {
                this.state.action == 'new' ? (
                  <form 
                    onSubmit={(e) => {
                      e.preventDefault();
                      !sendingMessage && this.handleSendMessage();
                    }}>
                    { 
                      sendingMessage &&
                      <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", "flex-direction": "column"}} className="d-flex justify-content-center align-items-center">
                        <p>Sending Message...</p>
                        <p><ClipLoader color={'#20a8d8'} /></p>
                      </div> 
                    }
                    <div className="form-group">
                      <label htmlFor="recipients">Recipient(s)</label>
                      <Select
                        placeholder="Type in the recipient name or scroll through recipient list..."
                        id="recipients"
                        isMulti={false}
                        components={{
                          Option: this.customRecipientOption,
                          SingleValue: this.customMultiValueLabel
                        }}
                        value={this.state.newConversation.recipients}
                        options={this.sortRecipients()}
                        onChange={(value) => {
                          this.setState({
                            newConversation: {
                              ...this.state.newConversation,
                              recipients: [value]
                            }
                          });
                        }} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message_body">Message</label>
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.newConversation.body}
                        onChange={(e) => {
                          this.setState({
                            newConversation: {
                              ...this.state.newConversation,
                              body: e.target.value
                            }
                          })
                        }} />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-info float-right">
                      Send
                    </button>
                  </form>
                ) : null
              }
              {
                this.state.action == 'show' ? (
                  this.state.messages.filter(m => m.conversationId == this.state.currentConversationId).length > 0 ? (
                    <div className='h-100 w-100'>
                      { sendingMessage &&
                        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", "flex-direction": "column"}} className="d-flex justify-content-center align-items-center">
                          <p>Sending Message...</p>
                          <p><ClipLoader color={'#20a8d8'} /></p>
                        </div> 
                      }
                      <div className='conversation-messages w-100'>
                        {
                          this.state.messages
                            .filter(m => m.conversationId == this.state.currentConversationId).map(m => (
                            <div
                              key={m.id}
                              className={classNames({
                                'mt-4 w-100 d-flex flex-row-reverse': m.sender.id == this.props.current_user_id,
                                'mt-4 w-100 d-flex flex-row': m.sender.id != this.props.current_user_id
                              })}>
                              <div className="w-70">
                                <div className="d-flex justify-content-between">
                                  { m.sender.id == this.props.current_user_id ? <div></div> : null  }
                                  <div><small className="message-sender text-muted">{m.sender.name}</small></div>
                                </div>
                                <div className="mt-1 d-flex justify-content-between">
                                  { m.sender.id == this.props.current_user_id ? <div></div> : null  }
                                  <div className=''>
                                    <p className={classNames({
                                      "message-body m-0" : true, 
                                      "sent" : m.sender.id == this.props.current_user_id, 
                                      "received" : m.sender.id != this.props.current_user_id})
                                    }>
                                      {m.body}
                                    </p>
                                    </div>
                                </div>
                                <div className="d-flex mt-1 justify-content-between">
                                  { m.sender.id == this.props.current_user_id ? <div></div> : null  }
                                  <div><small className="message-time text-muted">{moment(m.createdAt).format('MM/DD/YYYY hh:mm A')}</small></div>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                        <div style={{ float:"left", clear: "both" }} ref={(rr) => { this.messagesEnd = rr }}/>
                      </div>
                      <div className='conversation-form pt-3 pr-2'>
                        <form
                          className='message-form'
                          onSubmit={(e) => {
                            e.preventDefault();
                            this.handleSendMessage();
                          }}
                          onKeyPress={this.onKeyPress}
                          >
                          <div className="d-flex align-items-center">
                            <input
                              type="text"
                              className="form-control"
                              value={this.state.messageBody}
                              onChange={(e) => {
                                this.setState({
                                  ...this.state,
                                  messageBody: e.target.value
                                })
                              }} />
                              <div className="btn btn-primary ml-2" onClick={this.handeSendMessage}>Send</div>
                          </div>
                        </form>
                      </div>
                    </div>
                  ) : null
                ) : <div className="p-5 text-center text-muted"><i>No Conversation</i></div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Conversations
